import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import SmartBanner from 'react-smartbanner'
import type { IntlShape } from 'react-intl'
import { marketSelect } from '../utils'

type Props = {
    closeInsert: () => void,
    appInsertCloseTime?: number,
    appInsertViewCloseTime?: number,
    showAppBanner?: boolean,
    intl: IntlShape
}

class Insert extends Component<Props> {
    onInsertClose = () => {
        const { closeInsert } = this.props
        closeInsert()
    }

    render() {
        const {
            showAppBanner,
            appInsertCloseTime,
            appInsertViewCloseTime,
            intl
        } = this.props

        if (!showAppBanner) {
            return null
        }
        return (
            <SmartBanner
                title={intl.formatMessage({
                    id: marketSelect({
                        france: 'insert.appName',
                        reunion: 'insert.appName.reunion'
                    })
                })}
                storeText={{
                    ios: intl.formatMessage({ id: 'insert.iosStore' }),
                    android: intl.formatMessage({ id: 'insert.androidStore' })
                }}
                price={{
                    ios: intl.formatMessage({ id: 'insert.price' }),
                    android: intl.formatMessage({ id: 'insert.price' })
                }}
                button={intl.formatMessage({ id: 'insert.button' })}
                daysHidden={appInsertCloseTime}
                daysReminder={appInsertViewCloseTime}
                onClose={this.onInsertClose}
                onInstall={this.onInsertClose}
                ignoreIosVersion
            />
        )
    }
}

const InsertComponent = injectIntl(Insert)

export { InsertComponent }
